<template>
  <v-app>
    <nav-bar :hide-menu="false"></nav-bar>
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import NavBar from '@/layouts/components/NavBar.vue'

export default {
  name: 'MainLayout',
  components: {
    NavBar
  }
}
</script>
